import React, { useEffect, useState } from "react";
import {
	Box,
	Typography,
	styled,
	Stack,
	InputLabel,
	Button,
	LinearProgress,
} from "@mui/material";
import { useSelector } from "react-redux";
import {
	getDataFromLFStorage,
	LFStorageKeys,
	saveDataInLFStorage,
} from "../../../services/storage/LFStorage";
import {
	fetchContacts,
	newContactAddedStatus,
	selectedContactAction,
	syncContactsWithCache
} from "../../../state/actions/contacts";
import { showToast } from "../../../components/ui/toaster";
import { addContacts } from "../../../services/clients/ContactsService";
import CloseIcon from "@mui/icons-material/Close";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CustomTextField from "../components/FormInputField";
import Scrollbars from "react-custom-scrollbars-2";
import Avatar from "../../../components/common/Avatar";
import store from "../../../state/configureStore";
import { createUUID } from "../../../utils/Helpers";
import Error from "../../../components/common/Error";
import { PIVOTEL_DOMAINS } from "../../../utils/constants";
import { ACTIVE_BOX_BG_COLOR } from "../../../utils/ColorPicker";
import ModalCancelButton from "../../../components/ui/Modals/ModalMessages/ModalCancelButton";
import ModalConfirmButton from "../../../components/ui/Modals/ModalMessages/ModalConfirmButton";
import { FileApiServices } from "../../../services/api/FileServiceClient";
import { getAuthData } from "../../../services/storage/LocalStorage";
import { getUserProfileImageUrlThumbnail } from "../../../utils/general";
import { cloneDeep } from "lodash";

const StyledTypography = styled(Typography)({
	fontSize: "14px",
	color: "#404585",
	fontWeight: "600",
});

const NewContactFunctional = (props) => {
	const selectedDomain = useSelector((state) => state.domain.selectedDomain);
	const [errorMsg, setErrorMsg] = useState("");
	const [uploading, setUploading] = useState(false);
	const [name, setName] = useState("");
	const [percentCompleted, setPercentCompleted] = useState(0);
	const [userId, setUserId] = useState("");
	const [profilePhoto, setProfilePhoto] = useState(null);
	const [originalProfilePhoto, setOriginalProfilePhoto] = useState(null);
	const userDetails = getAuthData()?.user

	const [phoneType, setPhoneType] = useState([
		{
			type: "Mobile Number",
			placeholder: "Mobile",
			nputPlaceholderCode: "54",
			inputPlaceholderNumber: "Please enter your Mobile Number",
			countryCode: "",
			value: "",
		},
	]);

	const [phoneNumberTypeArr, setPhoneNumberTypeArr] = useState([
		{
			type: "satellite",
			placeholder: "Satellite",
			nputPlaceholderCode: "54",
			inputPlaceholderNumber: "Please enter your Satellite Number",
			countryCode: "",
			value: "",
		},
		{
			type: "mobile",
			placeholder: "Mobile",
			nputPlaceholderCode: "54",
			inputPlaceholderNumber: "Please enter your Mobile Number",
			countryCode: "",
			value: "",
		},
		{
			type: "land",
			placeholder: "Landline",
			nputPlaceholderCode: "54",
			inputPlaceholderNumber: "Please enter your Landline Number",
			countryCode: "",
			value: "",
		},
	]);
	const [emailType, setEmailType] = useState([
		{
			type: "home",
			placeholder: "Email home",
			value: "",
		},
	]);

	const getSelectedDomain = () => {
		let userDomain = selectedDomain;
		if (["vikand", "vikanduat"].includes(userDomain)) {
			return "Vikand";
		} else if (["onship"].includes(userDomain)) {
			return userDomain;
		} else if (PIVOTEL_DOMAINS.includes(userDomain)) {
			return "Pulsar";
		}
		return "FrontM";
	};

	let avatarStyle = profilePhoto
		? {
			borderRadius: "50%",
			background: "#fff",
			objectFit: "contain",
		}
		: {
			borderRadius: "50%",
			border: '2px solid #E7E7FF',
			width: "120px !important",
			height: "120px !important",
			padding: "30%",
		};

	const changeName = (e) => {
		e.preventDefault();
		setName(e.target.value);
		setErrorMsg('');
	};

	const addPhone = () => {
		let getPhoneNumberTypeArr = cloneDeep(phoneNumberTypeArr);
		let getArray = cloneDeep(phoneType);
		let numObj;
		let getNumber = [];
		for (let i = 0; i < getPhoneNumberTypeArr.length; i++) {
			if (
				getArray.findIndex(
					(elem) => elem.type === getPhoneNumberTypeArr[i].type
				) === -1
			) {
				numObj = getPhoneNumberTypeArr[i];
				getNumber.push(numObj);
				break;
			}
		}

		if (getArray.length >= 3) {
			return;
		}

		getArray.push(numObj);
		setPhoneType([...getArray]);
	};

	const addEmail = () => {
		let getArray = [...emailType];
		let newObj;

		if (getArray.length === 0) {
			newObj = {
				type: "home",
				placeholder: "Email home",
				value: "",
			};
		}
		if (getArray.length === 1 && getArray[0].type === "home") {
			newObj = {
				type: "work",
				placeholder: "Email work",
				value: "",
			};
		}

		if (getArray.length === 1 && getArray[0].type === "work") {
			newObj = {
				type: "home",
				placeholder: "Email home  ",
				value: "",
			};
		}
		if (getArray.length >= 2) {
			return;
		}

		getArray.push(newObj);
		setEmailType([...getArray]);
	};

const changeNumber = (e, index) => {
	let getArray = [...phoneType];
	let input = e.target.value;

	// Only allow input starting with '+' followed by digits
	const re = /^\+?[0-9]*$/;

	if (input === "") {
		// Clear input
		getArray[index].value = "";
		setPhoneType([...getArray]);
	} else if (re.test(input)) {
		// Auto-add '+' if it's the first character
		if (!input.startsWith("+")) {
			input = "+" + input;
		}
		getArray[index].value = input;
		setPhoneType([...getArray]);
	}
};


	const changeNumberCode = (index, e) => {
		let getArray = [...phoneType];
		const re = /^\+[0-9\b]*$/;
		if (
			!phoneType[index].countryCode ||
			(phoneType[index].countryCode &&
				phoneType[index].countryCode.length === 0)
		) {
			e.target.value = "+" + e.target.value;
		}
		if (
			e.target.value === "" ||
			(re.test(e.target.value) && e.target.value !== "+0")
		) {
			getArray[index].countryCode = e.target.value;
			setPhoneType([...getArray]);
		} else {
			e.preventDefault();
		}
	};

	const changeEmail = (e, index) => {
		let getArray = [...emailType];
		getArray[index].value = e.target.value;
		setEmailType([...getArray]);
	};

	const clearPhoneNumber = (e, index) => {
		let getArray = [...phoneType];
		getArray[index].value = '';
		setPhoneType([...getArray]);
	};

	const removePhone = (e, index) => {
		let getArray = [...phoneType];
		getArray.splice(index, 1);
		setPhoneType([...getArray]);
	};
	const clearEmail = (e, index) => {
		let getArray = [...emailType];
		getArray[index].value = '';
		setEmailType([...getArray]);
	};

	const removeEmail = (e, index) => {
		let getArray = [...emailType];
		getArray.splice(index, 1);
		setEmailType([...getArray]);
	};

	const addContactToCache = async (contactDetails) => {
		let contactsList =
			(await getDataFromLFStorage(
				`${LFStorageKeys.CONTACTS}_${selectedDomain}`
			)) || { localContacts: [] }; // <-- changed default to object

		// Ensure localContacts is an array
		if (!Array.isArray(contactsList.localContacts)) {
			contactsList.localContacts = [];
		}
		contactsList.localContacts.push(contactDetails);

		await saveDataInLFStorage(
			`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
			contactsList
		);
		store.dispatch(syncContactsWithCache(contactsList));
	};



	const addNewContact = (data) => {

		let saveArray = [];

		let saveContactObj = {
			userName: data.name,
			emailAddresses: {},
			phoneNumbers: {},
			userId: data.userId,
		};

		if (!data.name || data.name === "") {
			return;
		}
		if (data.emailType.length > 0) {
			data.emailType.forEach((elem, index) => {
				if (elem.value) {
					if (index === 0) {
						saveContactObj.emailAddresses["home"] = elem.value;
					} else {
						saveContactObj.emailAddresses["work"] = elem.value;
					}
				}
			});
		}
		if (data.phoneType.length > 0) {
			data.phoneType.forEach((elem, index) => {
				if (elem.value) {
					if (index === 0) {
						saveContactObj.phoneNumbers["satellite"] = elem.value;
					} else if (index === 1) {
						saveContactObj.phoneNumbers["mobile"] = elem.value;
					} else {
						saveContactObj.phoneNumbers["land"] = elem.value;
					}
				}
			});
		}
		console.log('saveContactObj', saveContactObj)
		saveArray.push(saveContactObj);
		store.dispatch(newContactAddedStatus(false));
		addContacts(saveArray, "form", selectedDomain)
			.then(() => {
				saveContactObj["contactType"] = "local";
				store.dispatch(newContactAddedStatus(true));

				store.dispatch(selectedContactAction(saveContactObj))
				if(selectedDomain){
				store.dispatch(fetchContacts({ selectedDomain: selectedDomain }))
				}
				
				addContactToCache(saveContactObj);
				if (!props?.selectedDomain?.viewModes?.chat) {
					if (props.history) {
						props.history.replace({
							...props.history.location,
							showSidebar: true,
						});
					}
				}
				showToast('success', `Contact ${saveContactObj?.userName} is created successfully`);

				props.handleCancel();
			})
			.catch((error) => {
				console.log("error ", error);
				showToast('error', `Error while adding the contact ${data.name}. Please try again later.`);

			});
	};

	const handleSubmit = () => {
		let currState = {};
		currState.phoneType = phoneType;
		currState.erroMsg = errorMsg;
		currState.name = name;
		currState.userId = userId;
		currState.profilePhoto = profilePhoto;
		currState.phoneNumberTypeArr = phoneNumberTypeArr;
		currState.emailType = emailType;
		console.log("data to save ", currState);

		if (!name) {
			setErrorMsg("Name field is required.");
			return;
		}

		if (phoneType.every((x) => x?.value === "")) {
			return setErrorMsg("Atleast one phone number is required.");
		}
		if (props.edit) {
			currState.userId = props.contact.userId;
		}
		addNewContact(currState);
	};

	const loadProfilePic = () => {
		let loggedInUser = store?.getState()?.user?.user?.userId || userDetails?.userId;

		const profileImageUrl = getUserProfileImageUrlThumbnail(loggedInUser + userId);

		setProfilePhoto(profileImageUrl);
	};


	const uploadPhoto = (e) => {
		let filesObj = e.target.files;
		if (!filesObj) {
			return;
		}
		let loggedInUser = store?.getState()?.user?.user?.userId || userDetails?.userId;
		setUploading(true);
		FileApiServices.uploadProfilePhoto(loggedInUser + userId + ".png", filesObj[0], selectedDomain)
			.then((response) => {
				setUploading(false);
				loadProfilePic();

			})
			.catch((error) => {
				setUploading(false);
			});
	};

	useEffect(() => {
		if (props.contact) {
			let contactData = { ...props.contact };
			let email = [];
			let phone = [];
			let newUserId = contactData.userId;
			if (contactData.emailAddresses) {
				Object.keys(contactData.emailAddresses).forEach((key) => {
					let emailObj = {};
					emailObj.type = key;
					if (key === "home") {
						emailObj.placeholder = "Email home";
					} else {
						emailObj.placeholder = "Email work";
					}
					emailObj.value = contactData.emailAddresses[key];
					email.push(emailObj);
				});
			} else {
				email = [
					{
						type: "home",
						placeholder: "Email home",
						value: "",
					},
				];
			}

			if (contactData.phoneNumbers) {
				Object.keys(contactData.phoneNumbers).forEach((key) => {
					let phoneObj = {};
					let number = contactData.phoneNumbers[key].split(" ");

					phoneObj.type = key;
					if (number.length > 0) {
						// phoneObj.countryCode = number[0];
						// phoneObj.value = number[1] === "undefined" ? "" : number[1];
						phoneObj.value = number[0] === "undefined" ? "" : number[0];
						if (
							number[1] === "null" ||
							number[1] === null ||
							number[1] === "" ||
							number[1] === "undefined"
						) {
							phoneObj.value = "";
						}
					}
					if (key === "satellite") {
						phoneObj.placeholder = "Satellite";
						phone.splice(0, 0, phoneObj);
					} else if (key === "mobile") {
						phoneObj.placeholder = "Mobile";
						phone.splice(1, 0, phoneObj);
					} else {
						phoneObj.placeholder = "Landline";
						phone.splice(2, 0, phoneObj);
					}
				});
			}

			if (!newUserId) {
				newUserId = createUUID();
			}
			setName(contactData.userName);
			setEmailType(email);
			setPhoneType(phone);
			setUserId(newUserId);
			setProfilePhoto(contactData.profilePhoto);
			setOriginalProfilePhoto(contactData.profilePhoto);
		} else {
			setUserId(createUUID());
		}
	}, []);

	return (
		<Scrollbars autoHide style={{ height: "30rem" }}>
			<StyledTypography>Create new contact</StyledTypography>
			{errorMsg && errorMsg.length > 0 && <div className={`d-flex flex-column p-2 ${selectedDomain}_font`}>
				<Error message={errorMsg} />
			</div>}
			<div className="p-2">
				<Stack flexDirection="row" justifyContent="center" alignItems="center" sx={{ width: '98%' }}>
					<Stack
						flexDirection="row"
						justifyContent="center"
						alignItems="center"
					>
						{!props ? (
							<Avatar
								style={avatarStyle}
								color="bg-fm-primary"
								name={name}
								size={120}
								imgSrc={profilePhoto || "/img/camera-icon-new.svg"}
							/>
						) : (
							<Avatar
								style={avatarStyle}
								name={name}
								size={120}
								height={
									profilePhoto === "/img/camera-icon-new.svg"
										? "auto"
										: 120
								}
								imgSrc={profilePhoto || "/img/camera-icon-new.svg"}
							/>
						)}
						<div style={{ position: 'relative', marginRight: '1rem' }}>
							<a
								className="primary-link my-2 d-flex justify-center items-center me-2"
								onClick={() => { }}
								style={{
									width: "23px",
									height: "23px",
									position: 'absolute',
									borderRadius: "50%",
									backgroundColor: "#f8f9fa",
									top: '20px',
									right: 0,
									zIndex: 9,
								}}
							>
								<InputLabel
									htmlFor="localContactImageBrowser"
									sx={{
										cursor: "pointer",
										marginBottom: 0,
										width: "30px",
										height: "30px",
									}}
									className="flex justify-center items-center"
								>
									<img src="/img/edit-icon-new.svg" width="23px" height="23px" style={{ borderRadius: '50%' }} />
								</InputLabel>
								<input
									type="file"
									id="localContactImageBrowser"
									name="customFile"
									accept=".png"
									onChange={(e) => uploadPhoto(e)}
									className="hidden"
								/>
							</a>
						</div>
					</Stack>
					<CustomTextField
						label={`Full Name`}
						placeholderValue="Enter the full name"
						value={name || ""}
						handleInputChange={changeName}
						EndAdornmentComponent={
							name && name.length > 0 && (
								<CloseIcon
									onClick={() => setName("")}
									sx={{ fontSize: "14px", cursor: "pointer" }}
								/>
							)
						}
						{...props}
					/>
				</Stack>
				{uploading && <LinearProgress />}
				<div className="p-2">
					{phoneType.map((elem, index) => {
						return (
							<div className="phone-container mt-3" key={index}>
								<Stack flexDirection='row' alignItems='center'>
									<CustomTextField
										label={elem?.type}
										placeholderValue={elem.inputPlaceholderNumber || "+54118930475"}
										value={elem.value || ""}
										handleInputChange={(e) => changeNumber(e, index)}
										EndAdornmentComponent={
											<>
												{
													elem?.value?.length > 0 &&
													<CloseIcon
														onClick={(e) => clearPhoneNumber(e, index)}
														sx={{ fontSize: "14px", cursor: "pointer" }}
													/>
												}
												{
													index !== 0 && (
														<Box
															onClick={(e) => removePhone(e, index)}
														>
															<DeleteOutlineIcon sx={{ fontSize: '1.5rem', cursor: 'pointer' }} />
														</Box>
													)}
											</>
										}
									/>
								</Stack>
							</div>
						);
					})}
					<div>
						{phoneType.length < 3 && (
							<Stack
								className={`${selectedDomain}_font p-2 `}
								flexDirection="row"
								sx={{ cursor: "pointer", width: "fit-content", marginTop: '-12px' }}
								alignItems="center"
								onClick={() => addPhone()}
							>
								<AddCircleIcon sx={{ fontSize: "14px", marginRight: "4px", color: '#8387BD' }} />
								<Typography sx={{ color: '#8387BD', fontSize: '13px', fontWeight: '600', fontFamily: 'Figtree-Regular' }}>Add phone</Typography>
							</Stack>
						)}
					</div>
				</div>

				<div className="p-2">
					{emailType.map((elem, index) => {
						return (
							<div className="phone-container mt-3" key={index}>
								<Stack flexDirection='row' alignItems='center' className={`${selectedDomain}_font my-1`}>
									<CustomTextField
										label={elem.placeholder}
										type="email"
										value={elem.value || ""}
										handleInputChange={(e) => changeEmail(e, index)}
										placeholderValue={elem.placeholder || "+54118930475"}
										maxLength={16}
										EndAdornmentComponent={
											<>
												{
													elem?.value?.length > 0 &&
													<CloseIcon
														onClick={(e) => clearEmail(e, index)}
														sx={{ fontSize: "14px", cursor: "pointer" }}
													/>
												}
												{
													index !== 0 && (
														<Box
															onClick={(e) => removeEmail(e, index)}
														>
															<DeleteOutlineIcon sx={{ fontSize: '1.5rem', cursor: 'pointer' }} />
														</Box>
													)}
											</>
										}
									/>
								</Stack>
							</div>
						);
					})}
					<div>
						{emailType.length < 2 && (
							<Stack
								className={`${selectedDomain}_font p-2`}
								flexDirection="row"
								alignItems="center"
								sx={{ cursor: "pointer", width: "fit-content", marginTop: '-12px' }}
								onClick={() => addEmail()}
							>
								<AddCircleIcon sx={{ fontSize: "14px", marginRight: "4px", color: '#8387BD' }} />
								<Typography sx={{ color: '#8387BD', fontSize: '13px', fontWeight: '600', fontFamily: 'Figtree-Regular' }}>Add email</Typography>
							</Stack>
						)}
					</div>
				</div>
			</div>
			<Stack className="under-modal-btn" flexDirection="row" justifyContent="space-around" sx={{ my: '20px' }}>
				<ModalCancelButton
					onClickFn={() => props.handleCancel()}
					label="Cancel"
					customWidth={200}
					className="modal-cancel !text-size-13"
				/>
				<ModalConfirmButton
					onClickFn={() => handleSubmit()}
					label="Save"
					className="!text-size-13"
					customWidth={200}
					customBgColor={ACTIVE_BOX_BG_COLOR}
				/>
			</Stack>
		</Scrollbars>
	);
};

export default NewContactFunctional;
